import { Platform, StyleSheet } from 'react-native';
import { colors } from '../../../shared/theme/colors'
import { spacing } from '../../../shared/theme/spacing'
import { typography } from '../../../shared/theme/typography'
import { ticketColors, ticketFonts } from '../../../shared/theme/ticketColors';

export const posCatalogProductStyleDefs = {
  loadingBox: {
      gap: spacing.sm,
      alignItems: 'center',
      justifyContent: 'center',
      paddingVertical: spacing.lg,
    },

  productList: {
      flex: 1,
      minHeight: 0,
      ...(Platform.OS === 'web' ? { height: '100%' as unknown as number } : null),
    },

  productListDesk: {
      backgroundColor: ticketColors.counter,
    },

  posCatalogListHost: {
      flex: 1,
      minHeight: 0,
    },

  posCatalogListHostDesk: {
      backgroundColor: ticketColors.counter,
    },

  posCatalogPaginationDock: {
      flexShrink: 0,
      borderTopWidth: 1,
      borderTopColor: ticketColors.ruleSoft,
      backgroundColor: ticketColors.paper2,
      paddingTop: 0,
    },

  productListContentEmpty: {
      flexGrow: 1,
    },

  productListEmptyFill: {
      flexGrow: 1,
      justifyContent: 'center',
    },

  productGridRow: {
      gap: spacing.sm,
      paddingHorizontal: spacing.sm,
    },

  /** Desk: el gutter vive en `contentContainerStyle` — evita doble inset vs paginación. */
  productGridRowDesk: {
      paddingHorizontal: 0,
    },

  disabledCard: {
      opacity: 0.55,
    },

  outOfStockBlockedCard: {
      opacity: 0.78,
    },

  productGridCardAddedFlash: {
      borderColor: colors.accent,
      backgroundColor: ticketColors.brandSoft,
    },

  productCardContent: {
      flex: 1,
      gap: spacing.sm,
      justifyContent: 'space-between',
    },

  productCardContentCompact: {
      gap: 5,
    },

  productTopRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      gap: spacing.sm,
    },

  productTopRowCompact: {
      alignItems: 'center',
      gap: spacing.xs,
    },

  productNameCol: {
      flex: 1,
      minWidth: 0,
      paddingRight: spacing.xs,
      overflow: 'hidden',
    },

  productName: {
      ...typography.body,
      color: colors.textPrimary,
      fontWeight: '800',
      lineHeight: 19,
    },

  productNamePosCompact: {
      fontSize: 15,
      lineHeight: 18,
    },

  productSku: {
      ...typography.caption,
      color: colors.textMuted,
      fontWeight: '600',
    },

  productSkuCompact: {
      fontSize: 11,
      lineHeight: 13,
    },

  productPrice: {
      ...typography.titleLg,
      color: colors.textPrimary,
      textAlign: 'right',
      flexShrink: 0,
      marginLeft: spacing.xs,
      fontWeight: '900',
    },

  productPriceCompact: {
      fontSize: 21,
      lineHeight: 25,
    },













  productFooterRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: spacing.sm,
    },

  productFooterRowCompact: {
      gap: spacing.xs,
    },

  productFooterRowStockOnly: {
      justifyContent: 'flex-start',
    },

  catalogPagerWrap: {
      gap: spacing.sm,
      marginTop: spacing.md,
      padding: 10,
      borderRadius: 14,
      borderWidth: 1,
      borderColor: ticketColors.ruleSoft,
      backgroundColor: colors.surface,
    },

  catalogPagerCanvasStrip: {
      gap: spacing.sm,
      marginTop: spacing.md,
      padding: 10,
      borderRadius: 14,
      borderWidth: 1,
      borderColor: ticketColors.ruleSoft,
      backgroundColor: colors.controlSurface,
    },

  catalogPagerCanvasStripRowWide: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: spacing.sm,
    },

  catalogPagerCanvasStripLabel: {
      ...typography.caption,
      color: colors.textSecondary,
      fontWeight: '800',
      flexShrink: 0,
    },

  catalogPagerCanvasStripCenter: {
      ...typography.caption,
      color: colors.textMuted,
      fontWeight: '600',
      flex: 1,
      textAlign: 'center',
      minWidth: 0,
    },

  catalogPagerCanvasStripCenterCompact: {
      textAlign: 'left',
    },

  catalogPagerCanvasRow: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: spacing.sm,
    },


  catalogPagerCanvasActions: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: spacing.xs,
      flexShrink: 0,
    },

  catalogPagerTopWrap: {
      paddingVertical: spacing.sm,
      paddingHorizontal: spacing.sm,
      marginBottom: spacing.xs,
      borderRadius: 14,
      borderWidth: 1,
      borderColor: ticketColors.ruleSoft,
      backgroundColor: colors.surface,
    },

  catalogPagerTopRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: spacing.sm,
    },

  catalogPagerTopSummary: {
      ...typography.caption,
      color: colors.textSecondary,
      fontWeight: '700',
      flex: 1,
      textAlign: 'center',
      minWidth: 0,
    },

  catalogPagerHint: {
      ...typography.caption,
      color: colors.textPrimary,
      textAlign: 'center',
      paddingHorizontal: spacing.md,
      fontWeight: '800',
    },

  catalogPager: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: spacing.sm,
    },

  catalogPagerButton: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: spacing.xs,
      paddingHorizontal: spacing.md,
      paddingVertical: spacing.sm,
      borderRadius: 999,
      borderWidth: 1,
      borderColor: colors.controlBorder,
      backgroundColor: colors.inputBackground,
    },

  catalogPagerButtonDisabled: {
      opacity: 0.45,
    },

  catalogPagerButtonText: {
      ...typography.caption,
      color: colors.textPrimary,
      fontWeight: '700',
    },

  catalogPagerButtonTop: {
      flexShrink: 0,
      paddingHorizontal: spacing.sm,
    },


  emptyCart: {
      ...typography.body,
      color: ticketColors.ink,
      fontWeight: '800',
      fontFamily: ticketFonts.sans,
      paddingVertical: 0,
    },






} as const;
